module.exports = __webpack_public_path__ + "static/nav-banner-car-ad887509084d8d955cfbcac4ed4e7908.png";